import React, { useEffect, useState, useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import styles from './TextEditot.module.css';

const FONT_SIZES = [
  '12px',
  '14px',
  '16px',
  '18px',
  '20px',
  '24px',
  '28px',
  '32px',
  '36px',
  '40px',
  '48px',
  '56px',
  '64px',
  '70px',
];

if (typeof window !== 'undefined') {
  const Quill = ReactQuill.Quill;
  const SizeStyle = Quill.import('attributors/style/size');
  SizeStyle.whitelist = FONT_SIZES;
  Quill.register(SizeStyle, true);
}

const TextEditor = ({
  name,
  value,
  onChange,
  errors,
  touched,
  label,
  right,
}) => {
  const [editorContent, setEditorContent] = useState(decodeHtml(value ?? ''));

  const handleEditorChange = (content) => {
    setEditorContent(content);
    onChange(name, content);
  };

  const modules = useMemo(
    () => ({
      toolbar: [
        [{ font: [] }],
        [{ align: [] }],
        [{ size: FONT_SIZES }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        ['blockquote'],
        [
          { list: 'ordered' },
          { list: 'bullet' },
          { indent: '-1' },
          { indent: '+1' },
        ],
        ['link'],
      ],
    }),
    []
  );

  const formats = [
    'font',
    'size',
    'align',
    'bold',
    'italic',
    'underline',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
  ];

  useEffect(() => {
    setEditorContent(decodeHtml(value ?? ''));
  }, [value]);

  function decodeHtml(html) {
    return (html || '')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }

  return (
    <div
      className={styles['textEditor-content']}
      style={{ minHeight: '200px' }}
    >
      {label && (
        <p className={`${styles['label']} ${right ? styles.right : ''}`}>
          {label} {errors && touched && <span>{errors}</span>}
        </p>
      )}
      <ReactQuill
        theme='snow'
        value={editorContent}
        onChange={handleEditorChange}
        modules={modules}
        formats={formats}
      />
    </div>
  );
};

export default TextEditor;
